import { IPartialReducer } from "../../../../core/core-redux/reduxTypes";
import { Wfs3dLayersState } from "../../wfs3dLayers.reducer";

export const wfs3dLayerReloadPartialReducer: IPartialReducer<Wfs3dLayersState> = () => {
    return {
        layers: [],
        loading: true,
    };
};
